import { TipoParentescoEnum } from './../../enums/tipo-parentesco.enum';
import { CivilStatus } from '../enum/civil-status.enum';
import { TipoIdentificacionLista } from './../../../components/individual-afiliate-beneficiary/model/tipo-identificacion';
import { WresponseData } from './../worker/wresponse-data';

export class ParentescoTipoIdentificacion {

  public static obtenerParenteso(trabajador: WresponseData): any {
    const casado  = CivilStatus.MARRIED.codigo
    const unionLibre  = CivilStatus.FREE_UNION.codigo
    const reglasParentesco = {
      "1" : {
        tiposIdentificacion: TipoIdentificacionLista.obtenerTodosTipoidentificacion(trabajador, TipoParentescoEnum.HIJO),
        afiliar: true,
        categoriasAfiliadoValidas : {A:'a',B:'b'},
        estadoCivilAfiliadoValidas : {casado:casado,unionLiblre:unionLibre}
      },
      "2" : {
        tiposIdentificacion: TipoIdentificacionLista.obtenerTodosTipoidentificacion(trabajador, TipoParentescoEnum.HIJASTRO),
        afiliar: trabajador.validacion_afiliado.afiliado.afiliacionPac.hijastro.afiliar,
        categoriasAfiliadoValidas : {A:'a',B:'b'},
        estadoCivilAfiliadoValidas : {casado:casado,unionLiblre:unionLibre}
      },
      "3" : {
        tiposIdentificacion: TipoIdentificacionLista.obtenerTipoidentificacionMayoresEdad(trabajador, TipoParentescoEnum.PADRE),
        afiliar: trabajador.validacion_afiliado.afiliado.afiliacionPac.padre.afiliar,
        categoriasAfiliadoValidas : {A:'a',B:'b'},
        estadoCivilAfiliadoValidas : {casado:casado,unionLiblre:unionLibre}

      },
      "33" : {
        tiposIdentificacion: TipoIdentificacionLista.obtenerTipoidentificacionMayoresEdad(trabajador, TipoParentescoEnum.MADRE),
        afiliar: trabajador.validacion_afiliado.afiliado.afiliacionPac.madre.afiliar,
        categoriasAfiliadoValidas : {A:'a',B:'b'},
        estadoCivilAfiliadoValidas : {casado:casado,unionLiblre:unionLibre}
      },
      "4" : {
        tiposIdentificacion: TipoIdentificacionLista.obtenerTodosTipoidentificacion(trabajador, TipoParentescoEnum.HERMANO),
        afiliar: trabajador.validacion_afiliado.afiliado.afiliacionPac.hermano.afiliar,
        categoriasAfiliadoValidas : {A:'a',B:'b'},
        estadoCivilAfiliadoValidas : {casado:casado,unionLiblre:unionLibre}
      },
      "5": {
        tiposIdentificacion:
        TipoIdentificacionLista.obtenerTipoidentificacionMayoresEdad(trabajador, TipoParentescoEnum.CONYUGE),
        afiliar: trabajador.validacion_afiliado.afiliado.afiliarConyuge,
        categoriasAfiliadoValidas: {A:'a',B:'b'},
        estadoCivilAfiliadoValidas: { casado: casado, unionLiblre: unionLibre },
      },
    }

    return reglasParentesco;
  }


}
